import React from 'react'

import { TabelaColuna } from 'src/componentes'

export const colunaDisciplinaCurso = (): TabelaColuna => ({
  Chave: 'nomeDisciplina',
  RenderizarCabecalho: () => <div style={{ width: 150 }}>Disciplina</div>
})
